export default "__VITE_ASSET__0cef3509__"